// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetCaseCode } from '@api';

export const getCaseCode = createAsyncThunk('landing/get_casecode', async args => {
  const response = await GetCaseCode();
  return response.data;
})

export const needHelpSlice = createSlice({
    name: 'needHelp',
    initialState: {
      accessCode:""
    },
    reducers:{},
    extraReducers: builder => {
      builder
      .addCase(getCaseCode.fulfilled, (state, action) => {
        state.accessCode = action.payload.code;
      })  
    }

})

//export const {} = eligibilityCheckSlice.actions

export default needHelpSlice.reducer